// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'

import router from './router'
import './rem'
//引入UI组件
import MintUI from 'mint-ui'
import store from '@/store'
import 'mint-ui/lib/style.css'
import JSEncrypt from 'jsencrypt';
Vue.use(MintUI)

// 藏品级别
Vue.filter('collectLeve', function (value) {
  if (!value) return ''
  let str = ''
  switch(value) {
    case '1':
      str = '一级'
      break
    case '2':
      str = '二级'
      break
    case '3':
      str = '三级'
      break
    case '4':
      str = '一般文物'
      break
    case '5':
      str = '未定级'
      break
  }
  return str
})

Vue.prototype.$getRsaCode = function(str){ // 注册方法
  let pubKey = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAs3sldCmBtHgQzy3ZBMV41W7MqH5WxorGq4Mvrm4ThFHoNw3+NbwaGggLm7rwn9D5g7huqUEpu/pW16g+Kdc+415yeuK3mhDkeEuICbnRoiR9lkvICbIL1749bOlHLOoOxqYE9N2ecfUPQMSPXTzYz7kXsPqo580Sr4idbhn5IIoNlBQx8076flwUD3GUQCykGbsdRB3ojBmjWOdxZARqHGlWpX8jY5JzJP4nrrtLicXkdEJ2qtmN/ucVrN+/0t5XDc/28kMvVfOAz7d7UuyyJK0QNJ6W88e1NSOswKLRt1axhXBnUnFLU+fjfBBQKxFjBGQ8vMWpQDVwxAKvm+geWQIDAQAB`;
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); // 设置 加密公钥
  let data = encryptStr.encrypt(str.toString());  // 进行加密
  return data;
}

router.afterEach((to,from,next) => {
  if(to.path == '/news' || to.path == '/zhanlan' || to.path == '/activity' || to.path == '/index') {
    $(".footmenu li").eq(0).addClass('router-link-exact-active').addClass('router-link-active')
  }else{
    $(".footmenu li").eq(0).removeClass('router-link-exact-active').removeClass('router-link-active')
  }
  window.scrollTo(0,0);
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  scrollBehavior:()=>({
    y:0
  }),
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js